import { MutationTree } from 'vuex';
import { IFieldState } from './field.types';
import { EFieldMutation } from './field.constants';
import { IField } from '@/dealroom/fields/types/field';

export const mutations: MutationTree<IFieldState> = {
  [EFieldMutation.SetLoading](state: IFieldState, loading: boolean) {
    state.loading = loading;
  },
  [EFieldMutation.SetDocumentId](state: IFieldState, documentId: string) {
    state.documentId = documentId;
  },
  [EFieldMutation.Set](state: IFieldState, fields: IField[]) {
    state.fields = fields;
  },
  [EFieldMutation.Add](state: IFieldState, fields: IField[]) {
    state.fields = [...state.fields, ...fields];
  },
  [EFieldMutation.Remove](state: IFieldState, fields: IField[]) {
    state.fields = state.fields.filter(
      (stateField: IField) => !fields.map((field: IField) => field.id).includes(stateField.id)
    );
  },
  [EFieldMutation.Update](state: IFieldState, field: IField) {
    state.fields = state.fields.map((stateField: IField) =>
      stateField.pageId === field.pageId && stateField.id === field.id ? field : stateField
    );
  },
  [EFieldMutation.SetPageWidth](state: IFieldState, pageWidth: number) {
    state.pageWidth = pageWidth;
  },
  [EFieldMutation.SetFocusedFieldId](state: IFieldState, fieldId: string) {
    state.focusedFieldId = fieldId;
  },
  [EFieldMutation.SetSenderSignature](state: IFieldState, senderSignature: string) {
    state.senderSignature = senderSignature;
  },
  [EFieldMutation.SetTabStartField](state: IFieldState, field: IField) {
    state.tabStartField = field;
  },
  [EFieldMutation.SetTabbedField](state: IFieldState, field: IField) {
    state.tabbedField = field;
  },
  [EFieldMutation.SetLastUpdatedFieldId](state: IFieldState, fieldId: string) {
    state.lastUpdatedFieldId = fieldId;
  },
};
